import axios from "@/libs/api.request.js";
import { getEnv } from "./heziShare";

// 活动会场列表
export const getActPlaceListApi = (data) => axios.request({ url: `${getEnv()}/wx-box-active/active/game/places`, data, requireToken: true });

// 获取活动规则
export const getActRule = (params) => axios.request({ url: `${getEnv()}/wx-box-active/app/getAppDocList`, params, method: "get", requireToken: true });

// 礼包领取记录游戏列表
export const getGameList = (data) => axios.request({ url: `${getEnv()}/wx-box-active/active/game/places/games`, data, requireToken: true });

// 礼包领取列表
export const getGiftRecordList = (data) => axios.request({ url: `${getEnv()}/wx-box-active/active/game/places/gift-record`, data, requireToken: true });

// 双11活动游戏会场导航栏接口
export const gamePlacesBanner = (data) => axios.request({ url: `${getEnv()}/wx-box-active/active/game/places/banner`, data, requireToken: true });

// 双11活动游戏会场打卡接口
export const gamePlacesSign = (data) => axios.request({ url: `${getEnv()}/wx-box-active/active/game/places/signIn`, data, requireToken: true });

// 双11活动游戏会场打卡信息
export const gamePlacesMainList = (data) => axios.request({ url: `${getEnv()}/wx-box-active/active/game/places/mainList`, data, requireToken: true });

// 双11活动游戏会场礼包领取
export const gamePlacesGiftReceive = (data) => axios.request({ url: `${getEnv()}/wx-box-active/active/game/places/gift-receive`, data, requireToken: true, unHint:true });

// -----------------  跟随 ios 盒子活动一起改版  -----------------
// 活动会场列表
export const getActPlaceListApiV2 = (data) => axios.request({ url: `${getEnv()}/wx-box-active/clockInActivity/getHomeList`, data, requireToken: true });

// 打卡活动礼包列表
export const getClockInGiftsV2 = (data) => axios.request({ url: `${getEnv()}/wx-box-active/clockInActivity/gameGiftList`, data, requireToken: true });

// 打卡
export const clockInOptV2 = (data) => axios.request({ url: `${getEnv()}/wx-box-active/clockInActivity/signIn`, data, requireToken: true });

// 领取礼包 
export const gamePlacesGiftReceiveV2 = (data) => axios.request({ url: `${getEnv()}/wx-box-active/clockInActivity/drawGift`, data, requireToken: true, unHint:true });

// 领取记录的游戏列表
export const getGameOpts = (data) => axios.request({ url: `${getEnv()}/wx-box-active/clockInActivity/placeGameInfos`, data, requireToken: true });

// 礼包领取列表
export const getGiftRecordListV2 = (data) => axios.request({ url: `${getEnv()}/wx-box-active/clockInActivity/giftDrawInfo`, data, requireToken: true });
